import { render, staticRenderFns } from "./events.vue?vue&type=template&id=6061054a"
import script from "./events.vue?vue&type=script&lang=js"
export * from "./events.vue?vue&type=script&lang=js"
import style0 from "./events.vue?vue&type=style&index=0&id=6061054a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports